// Libraries
import _cloneDeep from 'lodash-es/cloneDeep';
import { SearchUtils } from 'app_sasha/shared/models/SearchUtils';

// Afidium
export interface IConfig {
    name: string;
    shortName: string;
}

export interface ITicketingReportSearchParameters {
    system: string;
    agency: string;
    max: string | Date;
}

export interface IBookingInTicketingReportSearchParametersUrl {
    s?: string;
    ag?: string;
    max?: string;
}

export class TicketingReportSearchParameters implements ITicketingReportSearchParameters {
    public static STRING_PROPERTIES: IConfig[] = [
        { name: 'system', shortName: 's' },
        { name: 'agency', shortName: 'ag' },
    ];

    public static DATE_PROPERTIES: IConfig[] = [
        { name: 'max', shortName: 'max' }
    ];

    public system: string;
    public agency: string;
    public max: string;

    public static fromRouteParams(routeParams: IBookingInTicketingReportSearchParametersUrl): TicketingReportSearchParameters {
        const newParams: TicketingReportSearchParameters = new TicketingReportSearchParameters();
        TicketingReportSearchParameters.STRING_PROPERTIES
            .forEach((config: IConfig) => {
                if (routeParams[config.shortName]) {
                    newParams[config.name] = routeParams[config.shortName];
                }
            });

        TicketingReportSearchParameters.DATE_PROPERTIES
            .forEach((config: IConfig) => {
                if (routeParams[config.shortName]) {
                    newParams[config.name] = routeParams[config.shortName];
                }
            });

        return newParams;
    }

    public clone(): TicketingReportSearchParameters {
        return _cloneDeep(this);
    }

    public convertToUrlParameters(): IBookingInTicketingReportSearchParametersUrl {
        let urlParameters: IBookingInTicketingReportSearchParametersUrl = null;

        urlParameters = TicketingReportSearchParameters.STRING_PROPERTIES
            .reduce((parameters: IBookingInTicketingReportSearchParametersUrl, config: IConfig) => {
                return SearchUtils.setTextValue<IBookingInTicketingReportSearchParametersUrl>(parameters, this[config.name], config.shortName);
            }, urlParameters);

        urlParameters = TicketingReportSearchParameters.DATE_PROPERTIES
            .reduce((parameters: IBookingInTicketingReportSearchParametersUrl, config: IConfig) => {
                return SearchUtils.setDateValueIfNotEmpty<IBookingInTicketingReportSearchParametersUrl>(parameters, this[config.name], config.shortName);
            }, urlParameters);

        return urlParameters;
    }

    public clearValues(names: string[]): TicketingReportSearchParameters {
        names.forEach((name: string) => {
            this[name] = undefined;
        });

        return this;
    }
}
